import { mergeDeepRight } from "@smile2impress/attraction-utils";
import { defaultTheme } from "@smile2impress/themes";

import { colors } from "./foundations";

export const darkTheme = mergeDeepRight(defaultTheme, {
    name: "Impress Dark theme",
    initialColorMode: "dark",
    config: {
        initialColorMode: "dark",
    },
    colors,
} as Partial<typeof defaultTheme>);
